module.exports = __webpack_public_path__ + "images/3_NOON_ON_OFF.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/feeds/3_NOON_ON_OFF.jpg
// module id = 260
// module chunks = 0